import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://tcxjipfzwvxocsrfuazx.supabase.co';
const supabaseAnonKey = 'sb_publishable_ScYaUeOcmH9L_tKJsUB4HQ_b5dP5zen';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'jrwise_financial_auth',
  },
});
